import { CloseIcon, SkipIcon } from '../../../shared/ui/icons';
import type { TFlow } from '../../../entities/flow';

// The board draws a badge only for the two states worth a glance at the icon column;
// healthy/idle/paused/disabled/unpublished read from the State cell instead.
export const HealthGlyph = ({ health }: { health: TFlow['health'] }) => {
  if (health.state === 'failing') {
    return (
      <span
        title={health.hint ?? 'Failing'}
        className="flex size-4 items-center justify-center rounded-full bg-danger text-surface"
      >
        <CloseIcon size={9} />
      </span>
    );
  }
  if (health.state === 'degraded') {
    return (
      <span
        title={health.hint ?? 'Degraded'}
        className="flex size-4 items-center justify-center rounded-full bg-chip-on text-primary"
      >
        <SkipIcon size={9} />
      </span>
    );
  }
  return null;
};
